<div style="width: 100vw; height: 100vh; padding: 4rem">
  <div style="height: 100%; background: #99fcdf; overflow: hidden">
    @let _word = word();
    @if (_word) {
      <wk8-wisselklanken [targetWord]="_word" />
    }
  </div>
</div>
